import { useOrderContext } from "app/providers/OrderProvider";
import PriceTable from "entities/price-table";
import ProductItemExtra from "entities/product-item-extra";
import ProductsTotal from "entities/products-total";
import { usePaymentContext } from "pages/payment/providers/PaymentProvider";
import { useEffect } from "react";
import Card from "shared/ui/card";
import { concatClassnames } from "shared/utils/concatClassnames";
import { getFormattedPrice } from "shared/utils/getFormattedPrice";
import { PaymentActions } from "shared/utils/payment-methods";
import SelfAssemblySidebarProductsList from "widgets/self-assembly-sidebar/SelfAssemblySidebarProductsList";
import SidebarProductsList from "widgets/shared/sidebar-products-list";

interface PaymentSidebarProductsProps {
  className?: string;
  isSelfAssembly?: boolean;
}
const PaymentSidebarProducts = ({
  className = "",
  isSelfAssembly = false,
}: PaymentSidebarProductsProps) => {
  const orderContext = useOrderContext();
  const {
    order,
    getOrderSubtotal,
    getWarrantyPackageTotal,
    getRawOrderDiscountRecordsPrice,
    setRemaining,
    getOrderTotalRemaining,
    getOrderTotalPaid,
    getWarrantyPackageDiscount,
    warrantyPackage,
    setWarrantyDiscount,
    getWarrantyOwnRiskTotal,
    setTotal,
    getVoucherDiscount,
  } = useOrderContext();
  const { paymentAction, setPaymentMethod, customAmount, paymentMethod } =
    usePaymentContext();

  // TODO: Refactor and extract to custom hook
  useEffect(() => {
    let method = paymentAction || "PAY_LATER";
    // setPaymentMethod(method);

    if (method === "PAY_NOW") {
      let price = getOrderSubtotal();
      price += getWarrantyPackageTotal();
      price -= getRawOrderDiscountRecordsPrice();
      price = price * 0.1;
      price += orderContext.getRawSelfAssemblyDeliveryPrice();
      setRemaining(getFormattedPrice(price));
    }

    if (method === "PAY_FULL") {
      let price = getOrderTotalRemaining();

      if (getOrderTotalPaid() === 0) {
        setWarrantyDiscount(getWarrantyPackageDiscount(method));
        price -= getWarrantyPackageDiscount(method);
      } else {
        setWarrantyDiscount(0);
      }

      setRemaining(getFormattedPrice(price));
    } else {
      setWarrantyDiscount(0);
    }

    if (
      method === "PAY_LATER" ||
      method === "PAY_LATER_MONTHS" ||
      method === "PAY_LATER_TERMS"
    ) {
      setRemaining("€0,-");
    }

    if (method === "PAY_CUSTOM" && customAmount) {
      setRemaining(getFormattedPrice(customAmount));
    }
  }, [paymentAction, warrantyPackage, order]);

  useEffect(() => {
    let discountPrice = getRawOrderDiscountRecordsPrice();
    let warrantyPrice = getWarrantyPackageTotal();
    let ownRiskPrice = getWarrantyOwnRiskTotal();
    const voucherDiscount = getVoucherDiscount();

    let totalPrice =
      orderContext.getOrderSubtotal() +
      warrantyPrice +
      ownRiskPrice -
      discountPrice -
      voucherDiscount -
      orderContext.getWarrantyPackageDiscount(paymentMethod) +
      orderContext.getRawSelfAssemblyDeliveryPrice();

    setTotal(totalPrice);
  }, [order, warrantyPackage, getVoucherDiscount]);

  useEffect(() => {
    if (paymentAction === PaymentActions.PAY_CUSTOM && customAmount) {
      setRemaining(getFormattedPrice(customAmount));
    }
  }, [customAmount]);

  if (!order || !order.products) return null;

  return (
    <section className={concatClassnames("gg-grid", className)}>
      <Card shadow={false} className="!gg-bg-grey-500">
        <div className="gg-px-4 gg-pb-7 gg-pt-9 xl:gg-px-8">
          {order?.isSelfAssembly ? (
            <SelfAssemblySidebarProductsList products={order.products} />
          ) : (
            <SidebarProductsList products={order.products} />
          )}
        </div>

        <div className="gg-relative gg-grid gg-grid-cols-12 gg-items-center gg-justify-between gg-gap-y-5 gg-border-t gg-px-4 gg-py-7 xl:gg-px-8">
          <PriceTable
            entity={order}
            context={orderContext}
            className="gg-col-span-12"
          />

          <ProductItemExtra
            className={`gg-col-span-12 !gg-text-dark-blue-700 lg:gg-col-span-12 xl:gg-col-span-12`}
            entity={order}
          />

          <div className="gg-col-span-12 -gg-mx-8 gg-hidden sm:gg-block">
            <hr />
          </div>
          <ProductsTotal
            context={orderContext}
            entity={order}
            hideMonthlyPayment={order.shoppingCart?.sampleSale || false}
            className={`gg-col-span-12 gg-mt-4 gg-justify-self-end sm:gg-mt-0 md:gg-col-span-12 lg:gg-col-span-12 xl:gg-col-span-12`}
          />
        </div>
      </Card>
    </section>
  );
};
export default PaymentSidebarProducts;
